import { render } from "./ModalPolicy.vue?vue&type=template&id=2506b468&scoped=true"
import script from "./ModalPolicy.vue?vue&type=script&lang=js"
export * from "./ModalPolicy.vue?vue&type=script&lang=js"

import "./ModalPolicy.vue?vue&type=style&index=0&id=2506b468&rel=scss&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2506b468"]])

export default __exports__